"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "RadioGroupField", {
  enumerable: true,
  get: function get() {
    return _RadioGroupField["default"];
  }
});
exports["default"] = void 0;

var _RadioGroupField = _interopRequireWildcard(require("../RadioGroupField"));

/**
 * DEPRECATED - only exists for backwards compatibility
 */
var _default = _RadioGroupField.RadioGroup;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@zillow/react-zsg/Form/RadioGroup.js
// module id = 494
// module chunks = 0